import React from 'react'
import WorkflowTab from '../Components/Tab Component/WorkflowTab';
import './Home.css';


const Home = ( {selectedIndex}) => {
  // Getting the selectedIndex and passing to Workflow tab
  return (
   <>
   <div className='home'>
   <WorkflowTab selectedIndex={selectedIndex}/>
   </div>
   </>
  )
}

export default Home